import React, { useCallback, useMemo, useState } from 'react';
import { EntityStatus, IItemForGetShortInfoWithStatus } from 'types';
import { SHOW_ARCHIVED_CUSTOMERS, SHOW_ARCHIVED_RESTAURANTS } from 'appConstants';
import { ISelectOption } from 'components/Select/types';
import { ArchivedLabel } from 'components/Select/ArchivedLabel';

interface IUseArchivedSingleSelectParams {
	items: IItemForGetShortInfoWithStatus[];
	entityType: 'restaurants' | 'customers';
	keepVisibleIds: string[];
}

export const useArchivedSingleSelect = ({ items, entityType, keepVisibleIds }: IUseArchivedSingleSelectParams) => {
	const storageKey = entityType === 'restaurants' ? SHOW_ARCHIVED_RESTAURANTS : SHOW_ARCHIVED_CUSTOMERS;
	const [showArchived, setShowArchived] = useState<boolean>(localStorage.getItem(storageKey) === 'true');

	const toggleShowArchived = useCallback(() => {
		localStorage.setItem(storageKey, JSON.stringify(!showArchived));
		setShowArchived((prevValue) => !prevValue);
	}, [showArchived, storageKey]);

	const options = useMemo<ISelectOption[]>(() => {
		const visibleItems = showArchived
			? items
			: items.filter((item) => item.status === EntityStatus.Active || keepVisibleIds.includes(item.id));

		return visibleItems.map((item) => ({
			...item,
			additionalContent: item.status === EntityStatus.Archived ? <ArchivedLabel /> : undefined,
		}));
	}, [items, showArchived, keepVisibleIds]);

	return { showArchived, toggleShowArchived, options };
};
